import {
    HttpResponse,
    FindingModel,
    QueryModel,
    RequestParams,
    FindingModelIEnumerableApiResultSuccess,
    FindingModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";
import {CrudPartialUpdatePatch} from '@/libs/core/+state/models/crud-partial-update-patch';

export class FindingsDataService implements CrudService<FindingModel, FindingModel> {
    getAll(query: CrudDataQuery<FindingModel>): Promise<CrudEnumerableResponse<FindingModel>> {
        return ApiService.api.getFindingBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<FindingModel>): Promise<CrudEnumerableResponse<FindingModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<FindingModel>> {
        return ApiService.api.getFindingById(id, params);
    }

    create(item: FindingModel, params?: RequestParams): Promise<CrudResponse<FindingModel>> {
        return ApiService.api.insertFinding(item, params);
    }

    update(item: FindingModel, params?: RequestParams): Promise<FindingModel> {
        return ApiService.api.updateFinding(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<FindingModel> {
        return ApiService.api.patchFinding(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<FindingModel>): Promise<CrudEnumerableResponse<FindingModel>> {
        return ApiService.api.deleteFindings(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationFinding(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<FindingModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: FindingModel, params?: RequestParams): Promise<CrudResponse<FindingModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getFindingGroupped(query, params);
    }

}
